import React from 'react';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import { style } from 'typestyle';
import { BuyBoxIcon } from '../../Icons/LayoutIcons/BuyBox';
import { SpotlightIcon } from '../../Icons/LayoutIcons/Spotlight';
import { UniformIcon } from '../../Icons/LayoutIcons/Uniform';
import { QuickSettings } from '../types/QuickSettings';

interface Props {
  value?: QuickSettings['carousel_type'];
  onChange: (type: NonNullable<QuickSettings['carousel_type']>) => void;
}

interface OptionProps {
  icon: React.ReactNode;
  label: string;
}

const CarouselTypeSelector = ({ value = 'spotlight', onChange }: Props) => {
  return (
    <div className={selectClass}>
      <TypeOption
        icon={
          <SpotlightIcon
            selected={value === 'spotlight'}
            onClick={() => onChange('spotlight')}
          />
        }
        label={lang.labels.spotlight}
      />
      <TypeOption
        icon={
          <UniformIcon
            selected={value === 'uniform'}
            onClick={() => onChange('uniform')}
          />
        }
        label={lang.labels.uniform}
      />
      <TypeOption
        icon={
          <BuyBoxIcon
            selected={value === 'buy_box'}
            onClick={() => onChange('buy_box')}
          />
        }
        label={lang.labels.buy_box}
      />
    </div>
  );
};

const TypeOption = ({ icon, label }: OptionProps) => {
  return (
    <div className={itemClass}>
      {icon}
      <div className={labelClass}>{label}</div>
    </div>
  );
};

const selectClass = style({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  width: '100%',
  marginTop: '5px',
  marginBottom: '10px',
});

const itemClass = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  cursor: 'pointer',
  width: '70px',
});

const labelClass = style({
  color: 'white',
  fontSize: '0.7em',
  textAlign: 'center',
  textTransform: 'uppercase',
  marginTop: '5px',
});

const lang = LocalizedStrings({
  en: {
    labels: {
      spotlight: 'Spotlight',
      uniform: 'Uniform',
      buy_box: 'Buy Box',
    },
  },
});

export { CarouselTypeSelector };
